// Market detection. Liquid sets the starting class on <html> from localization.country.
// Visitors whose country isn't in an active market are served the primary (UK) market,
// so Liquid reports GB for them. When Liquid says GB, ask Shopify's geolocation endpoint
// for the visitor's real country and switch to the right copy. If anything fails, the
// UK view stays and checkout still blocks non-UK addresses.
// For testing, add ?onz_country=DE (or any ISO code) to a URL; ?onz_country=reset clears it.
(function () {
  var html = document.documentElement;
  var euCodes = (html.getAttribute('data-eu-codes') || '').split(',');
  var KEY = 'onz-country';

  function store(code) {
    try { code ? sessionStorage.setItem(KEY, code) : sessionStorage.removeItem(KEY); } catch (e) {}
  }
  function stored() {
    try { return sessionStorage.getItem(KEY); } catch (e) { return null; }
  }

  function apply(code) {
    if (!code) return;
    code = String(code).toUpperCase();
    var mkt = (code === 'GB' || code === 'IM') ? 'uk' : (euCodes.indexOf(code) > -1 ? 'eu' : 'row');
    html.classList.remove('mkt-uk', 'mkt-eu', 'mkt-row');
    html.classList.add('mkt-' + mkt);
    html.setAttribute('data-visitor-country', code);
    document.querySelectorAll('[data-waitlist-tags]').forEach(function (input) {
      input.value = 'eu-waitlist, country-' + code;
    });
  }

  var override = null;
  try { override = new URLSearchParams(window.location.search).get('onz_country'); } catch (e) {}
  if (override === 'reset') { store(null); override = null; }
  if (override) { store(override.toUpperCase()); apply(override); return; }

  var liquidCountry = html.getAttribute('data-mkt-country');
  if (liquidCountry && liquidCountry !== 'GB') { apply(liquidCountry); return; }

  var cached = stored();
  if (cached) { apply(cached); return; }

  if (!window.fetch) return;
  fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var c = data && data.detected_values && data.detected_values.country;
      var code = c && (c.handle || c.code);
      if (code) { store(String(code).toUpperCase()); apply(code); }
    })
    .catch(function () {});
})();
